import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${buildColor("white", "900")};
  padding-bottom: 20px;
`;

export const Main = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  padding: 0 12px;
`;

export const ValueContainer = styled.div`
  flex: 1;
  flex-direction: column;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 44px;
  margin-top: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 12px;
`;
